import {
    DisplaySchool,
    SCHOOL_DISPLAY_STATUS_HIDDEN,
    SCHOOL_DISPLAY_STATUS_VISIBLE,
    SCHOOL_LINK_STATUS_LINKED,
    SCHOOL_LINK_STATUS_NOT_LINKED,
    SCHOOL_LINK_STATUS_STOPPED,
    SchoolClassification,
    SchoolType,
    StatusSchool
} from "@/core/option/schoolLinkSource";

const LEGACY_LINKED_STATUS_NAMES = ['Vận hành']

export class SchoolLinkModel {
    constructor(school = {}) {
        const statusValue = this.normalizeStatusValue(school.status);
        const displayValue = this.resolveDisplayValue(school);
        const schoolTypeValue = school.school_type ?? school.school_type_id ?? school.type_school ?? school.type_school_id;
        const classificationValue = school.classify ?? school.classification ?? school.classification_id ?? school.school_classification ?? school.school_classification_id;

        this.idSchool = school.id;
        this.nameSchool = school.name ?? '';
        this.districtName = this.resolveName(school.district_name ?? school.district ?? school.ward ?? school.ward_name ?? school.commune ?? school.commune_name);
        this.provinceName = this.resolveName(school.province ?? school.province_name);
        this.statusName = this.getStatusName(statusValue);
        this.isLinked = this.checkLinkedStatus(statusValue);
        this.canLink = this.checkCanLinkStatus(statusValue);
        this.statusClass = this.getStatusClass(statusValue);
        this.nextStatusValue = this.isLinked ? SCHOOL_LINK_STATUS_STOPPED : SCHOOL_LINK_STATUS_LINKED;
        this.changeStatusTitle = this.isLinked ? 'Ngừng liên kết' : 'Liên kết';
        this.displayName = this.getOptionName(DisplaySchool, displayValue, '');
        this.displayClass = this.getDisplayClass(displayValue);
        this.schoolTypeName = this.getOptionName(SchoolType, schoolTypeValue, '');
        this.classificationName = this.getOptionName(SchoolClassification, classificationValue, '');
        this.checkVoucherOngoing = school.check_voucher_ongoing;
        this.checkDelete = school.check_delete;
    }

    getOptionName(options, value, fallback = value) {
        return options.find((option) => String(option.value) === String(value))?.name ?? fallback;
    }

    getStatusName(status) {
        return this.getOptionName(StatusSchool, status, status ?? '');
    }

    normalizeStatusValue(status) {
        if (LEGACY_LINKED_STATUS_NAMES.includes(status)) {
            return SCHOOL_LINK_STATUS_LINKED;
        }

        return StatusSchool.find((option) => String(option.value) === String(status) || option.name === status)?.value ?? status;
    }

    checkLinkedStatus(status) {
        return String(status) === String(SCHOOL_LINK_STATUS_LINKED);
    }

    checkCanLinkStatus(status) {
        return [SCHOOL_LINK_STATUS_STOPPED, SCHOOL_LINK_STATUS_NOT_LINKED].some((item) => String(item) === String(status));
    }

    getStatusClass(status) {
        if (String(status) === String(SCHOOL_LINK_STATUS_LINKED)) {
            return 'status-success';
        }

        if (String(status) === String(SCHOOL_LINK_STATUS_NOT_LINKED)) {
            return 'status-not-linked';
        }

        return 'status-error';
    }

    getDisplayClass(displayValue) {
        if (String(displayValue) === String(SCHOOL_DISPLAY_STATUS_VISIBLE)) {
            return 'display-status-visible';
        }

        if (String(displayValue) === String(SCHOOL_DISPLAY_STATUS_HIDDEN)) {
            return 'display-status-hidden';
        }

        return '';
    }

    resolveDisplayValue(school) {
        const value = school.display ?? school.display_status ?? school.visible ?? school.is_visible ?? school.action;

        if (typeof value === 'boolean') {
            return value ? SCHOOL_DISPLAY_STATUS_VISIBLE : SCHOOL_DISPLAY_STATUS_HIDDEN;
        }

        return value;
    }

    resolveName(value) {
        if (!value) {
            return '';
        }

        return typeof value === 'object' ? value.name ?? '' : value;
    }
}
